import { MutationHookOptions, useMutation } from "@apollo/client";

import { LoginUserMutation, LoginUserMutationVariables } from "@ctypes";
import { LOGIN_USER } from "@graphql";

export const useLogin = (
  options?: MutationHookOptions<LoginUserMutation, LoginUserMutationVariables>,
) => {
  return useMutation<LoginUserMutation, LoginUserMutationVariables>(LOGIN_USER, options);
};
